import { Component, OnInit, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../services/http-service.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IbisReport } from '../../model';
import { ibisQueryParam } from '../../model/ibis-models';
import { CreateIbisReportComponent } from '../../modal';
import { LogService } from 'src/app/services';
@Component({
  selector: 'ibis-editor',
  templateUrl: './ibis-editor.component.html',
  styleUrls: ['./ibis-editor.component.scss']
})

export class IbisEditorComponent implements OnInit {
  ibisList:IbisReport[] = [];
  totalItems:number = 0;
  modalRef: BsModalRef;
  files: NgxFileDropEntry[] = [];
  showProgress:boolean = false;
  isAllFilesUploaded: boolean = false;
  progress:number = 0;
  loading:boolean = false;
  ibisQueryParam:ibisQueryParam = new ibisQueryParam();
  createModal: BsModalRef;
  searchChanged: Subject<string> = new Subject<string>();

  constructor(
    public httpClient:HttpClient,
    public httpService:HttpService,
    public modalService: BsModalService,
    public router: Router,
    private logService: LogService
  ) {
    this.searchChanged.pipe(debounceTime(1000)).subscribe(() => {
      this.getIbisList();
    });
  }

  ngOnInit(): void {
    let sorting = localStorage.getItem('RESEARCH-INDUSTRY-SORT');
    if(sorting){
      sorting = JSON.parse(sorting);
      this.ibisQueryParam.field = sorting['FIELD'];
      this.ibisQueryParam.order = sorting['ORDER'];
    }
    this.getIbisList();
  }

  filterList(): void{
    this.searchChanged.next();
  }

  // getIbisList() - Get list of all ibis.
  getIbisList(): void {
    this.loading = true;
    this.httpService.getIbisList(this.ibisQueryParam).subscribe((resp) => {
      if(resp.success){
        this.ibisList = resp.result.items;
        this.totalItems = resp.result.totalItems;
        this.loading = false;
      }
    }, (error) => {
      if (error) {
        this.loading = false;
       // this.toastrService.error(error.message);
      }
    });
  }

  // sortIbis() - sort ibis list.
  sortIbis(fieldName:string): void {
    if(this.ibisQueryParam.field === fieldName){
      if(this.ibisQueryParam.order === 'ASC')
        this.ibisQueryParam.order = 'DESC';
      else
        this.ibisQueryParam.order = 'ASC';
    }else{
      this.ibisQueryParam.field = fieldName;
      this.ibisQueryParam.order = 'ASC';
    }
    localStorage.setItem('RESEARCH-INDUSTRY-SORT', JSON.stringify({ORDER: this.ibisQueryParam.order, FIELD: this.ibisQueryParam.field}));
    this.getIbisList();
  }

  // pageChanged() - Event is fired when page is changed
  pageChanged(event): void {
    this.ibisQueryParam.page = event.page;
    this.getIbisList();
  }

  // removeIbis() - Remove ibis
  removeIbis(ibis:IbisReport): void {
    this.httpService.removeIbisItem(ibis.ID).subscribe((resp) => {
      if(resp.success){
       let index = this.ibisList.indexOf(ibis); 
       this.ibisList.splice(index, 1);
      }
    }, (error) => {
      if (error) {
       // this.toastrService.error(error.message);
      }
    });
  }

  // downloadPDF() - Download pdf
  downloadPDF(ibis:any): void {
    let requestObj = new IbisReport();
    requestObj.ID = ibis.ID;
    requestObj.NAME = ibis.NAME;
    requestObj.DATE = ibis.DATE;
    requestObj.CODE = ibis.CODE;

    this.httpService.downloadIbisFile(requestObj).subscribe((resp) => {
      if(resp.success){
        this.logService.log(resp);
      }
    }, (error) => {
      if (error) {
       // this.toastrService.error(error.message);
      }
    });
  }

  // openModal() - Append text when object is dropped on area.
  openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, { backdrop: 'static', class: 'modal-width' });
  }

  // closeModal() - Close modal.
  closeModal(): void {
    this.modalRef.hide();
    this.isAllFilesUploaded = false;
    this.showProgress = false;
    this.files = [];
  }

  // dropped() - Do operations when file is dropped
  dropped(files: NgxFileDropEntry[]): void {
    this.files = files;
    let fileArray:any[] = [];

    for (const droppedFile of files) {

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          // Add file into array for Uploading file to the server
          if(file.type === 'application/pdf'){
            fileArray.push(file);

            if(files.length == fileArray.length){
              this.uploadFileToServer(fileArray);
            }
          }

        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }

  // uploadFileToServer() - Upload file to server.
  uploadFileToServer(fileArray:string[]): void {
    if(fileArray.length > 0){
      this.showProgress = true;
      this.progress = 0;
      const contentParam:FormData = new FormData();
      fileArray.map(data => {
        contentParam.append('files', data);
      });

      this.httpService.createIbisItem(contentParam).subscribe((resp) => {
        if(resp.success){
          this.progress = 100;
          setTimeout(() => {
            this.isAllFilesUploaded = true;
           // this.toastrService.success('All files are uploaded successfully');
            this.showProgress = false;
            this.getIbisList();
          }, 1000);
        }else{
          this.showProgress = false;
          this.progress = 0;
        }
      }, (error) => {
        if (error) {
          this.showProgress = false;
          this.progress = 0;
         // this.toastrService.error(error.message);
        }
      });

      // Logic behind progress bar
      for(let i=0; i<10; i++){
        if(i <= 3){
          setTimeout(() => {
            this.progress = this.progress + 20;
          }, (i * 500));
        }else if (i > 3 && this.progress < 100){
          setTimeout(() => {
            if(this.progress <= 99){
              this.progress = this.progress + 3;
            }
          }, (i * 400));
        }
      }
    }
  }

  openFileSelector(): void{}

  /** Create IBIS Report */
  createIBISReport(report: IbisReport): void{
    if(report !== null)
      this.router.navigate(['/manage/research/ibis/edit/' + report.ID]);
    else this.router.navigate(['/manage/research/ibis/create']);
  }

  /** Open modal to add new block of map or location */
  openCreateIbisReportModal(): void{
    this.createModal = this.modalService.show(CreateIbisReportComponent, {backdrop: 'static'});
    const ackSubject = new Subject<any>();
    this.createModal.content.subject = ackSubject;
    
    ackSubject.subscribe(value => {
      if (value) {
        let data = window.btoa(JSON.stringify({
          CODE: value.CODE,
          NAME: value.NAME,
          DATE: value.DATE
        }));
        this.router.navigate(['/manage/research/ibis/create/' + data]);
      }
    });
  }

  createIBIS(): void {
    this.router.navigate(['/manage/research/ibis/create']);
  }
}
